import React, { useState, useEffect, useRef } from 'react'
import './input.scss'
import Image from '../Image'

const Input = ({ placeholder, label, info, rules, onChange, defaultValue, error, errorText, closeable, ...props }) => {
  const inputRef = useRef()
  const [Error, setError] = useState(null)
  const changeFn = (e, type) => {
    let value = type ? e : e.target.value
    if (rules) {
      let check = []
      if (value || value === 0) {
        rules.forEach(r => {
          if (r.pattern) {
            if (!r.pattern.test(value)) check.push({ key: "pattern", message: r.message })
          }
          if (r.type === 'range') {
            let num = value * 1
            if (num >= r.min && num <= r.max) {

            } else {
              check.push({ key: "range", message: r.message })
            }
          }
        })
      }
      if (check.length) {
        setError(check[0]['message'])
        onChange('')
      } else {
        setError(null)
        onChange(value)
      }
    } else {
      onChange(value)
    }
  }
  useEffect(() => {
    inputRef.current.value = defaultValue || ""
  }, [defaultValue])
  return (
    <div className={`input-container ${Error || error ? 'input-container-error' : ''}`}>
      {label && <label>{label}</label>}
      {info && (<label style={{ color: "rgba(117,117,117,1)" }}>{info}</label>)}
      <div className='input-block'>
        <input
          className={closeable ? 'input-closable' : ''}
          ref={inputRef}
          onChange={changeFn}
          placeholder={placeholder} {...props} />
        {
          (Error || errorText) && (<p className='error'>{Error || errorText}</p>)
        }
        {closeable && defaultValue &&
          <div className='close-btn' onClick={() => changeFn("", true)}>
            <Image src='/images/icons/close.svg' svg />
          </div>
        }

      </div>
    </div>
  )
}

export default Input